export default {
      id: "logo_footer-usage",
      viewBox: "0 0 200 169",
      url: "../dist/images/" + "sprite.svg#logo_footer-usage",
      toString: function () {
        return this.url;
      }
    }